import type { HTMLAttributes } from "react";
import { cn } from "../cn";

export type PropsRkDivider = HTMLAttributes<HTMLHRElement> & {
  readonly brand?: boolean;
};

export function Divider({ brand = false, className, ...resto }: PropsRkDivider) {
  return (
    <hr
      {...resto}
      className={cn("rk-divider", brand && "rk-divider--brand", className)}
    />
  );
}
